import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import { LocationsDashboard } from "../LocationsDashboard";

export default {
  icon: MapOutlinedIcon,
  list: LocationsDashboard,
};
